import { render, staticRenderFns } from "./overview-main-card-expandable.component.vue?vue&type=template&id=75d83c26&scoped=true&"
import script from "./overview-main-card-expandable.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card-expandable.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card-expandable.component.vue?vue&type=style&index=0&id=75d83c26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d83c26",
  null
  
)

export default component.exports